import { render, staticRenderFns } from "./FilterProductCollections.vue?vue&type=template&id=42907052&"
import script from "./FilterProductCollections.vue?vue&type=script&lang=js&"
export * from "./FilterProductCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports